import React from 'react'
import '../assets/css/constans/constant.scss'

const Header = ({ logo, contentLinks }) => {
    return (
        <div className="header">
            <a href={contentLinks && contentLinks.data ? contentLinks.data.brand?.websiteUrl : '#'}>
                <div className="logo-content">
                    {logo}
                </div>
            </a>
        </div>
    )
}

export default Header